<app-main-menu></app-main-menu>
<div class="content">
    <p-panel styleClass="margin-top-10">
        <ng-template pTemplate="icons">
            <button pButton pRipple class="p-panel-header-icon p-link" (click)="homeUrlNav()" icon="pi pi-home">
            </button>
        </ng-template>
        <ng-template pTemplate="header">
            QUẢN LÝ LOẠI HỢP ĐỒNG
        </ng-template>
        <div class="card">
            <p-splitter class="p-col-12">
                <ng-template pTemplate>
                    <p-card class="p-col-12">
                        <h5>DANH SÁCH LOẠI HỢP ĐỒNG</h5>
                        <p-table [paginator]="true" [rows]="pageSize" [totalRecords]="totalRecords" [loading]="loading"
                            [lazy]="true" [rowsPerPageOptions]="[10,25,50]" [value]="data" [(first)]="pageNumber"
                            styleClass="p-datatable-sm" (onLazyLoad)="getLHD($event)">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>Tên loại hợp đồng</th>
                                    <th style="width: 90px;text-align: center;">#</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-data>
                                <tr>
                                    <!-- <td>{{data.id}}</td> -->
                                    <td>{{data.tenloaihopdong}}</td>
                                    <td style="text-align: center;">
                                        <button pButton pRipple type="button" icon="pi pi-user-edit"
                                            class="p-button-rounded p-button-outlined"
                                            (click)="getInfo(data.id)"></button>
                                        <button pButton pRipple type="button" icon="pi pi-trash"
                                            class="p-button-rounded p-button-outlined p-ml-2"
                                            (click)="delete(data.id)"></button>
                                    </td>
                                </tr>
                            </ng-template>

                            <ng-template pTemplate="paginatorright">
                                <p-button type="button" icon="pi pi-home" styleClass="p-button-text"
                                    (onClick)="homeUrlNav()">
                                </p-button>
                            </ng-template>
                        </p-table>
                    </p-card>
                </ng-template>

                <!-- <p-divider layout="vertical"></p-divider> -->
                <ng-template pTemplate>
                    <p-card class="p-col-12">
                        <h5>THÔNG TIN LOẠI HỢP ĐỒNG</h5>
                        <form [formGroup]="infoLoaiHopDongForm" novalidate (submit)="saveLoaiHopDong()">
                            <div class="p-fluid">
                                <div class="p-field">
                                    <label for="tenLoaiHopDong">Tên loại hợp đồng</label>
                                    <input id="tenLoaiHopDong" type="text" pInputText formControlName="tenLoaiHopDong">
                                </div>
                                <div class="p-fluid p-formgrid p-grid">
                                    <div class="p-field p-col">
                                        <button pButton pRipple type="submit" label="Thêm/Sửa"
                                            class="p-button-raised"><i class="pi pi-save"></i>&nbsp;</button>
                                    </div>
                                    <div class="p-field p-col">
                                        <button pButton pRipple type="button" label="Xóa thông tin"
                                            class="p-button-raised p-button-warning" (click)="resetForm()"><i
                                                class="pi pi-trash"></i>&nbsp;</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </p-card>
                </ng-template>
            </p-splitter>
        </div>
    </p-panel>
</div>